/* eslint-disable camelcase */
import React, { useState, useEffect } from "react";
import { ChefHat } from "ceicons";
import Rating from "react-rating";
import "./difficultyRate.scss";

const difficultyParsed = {
  LOW: 1,
  MEDIUM: 2,
  HIGH: 3,
  1: "LOW",
  2: "MEDIUM",
  3: "HIGH",
};

export default function DifficultyRate({
  difficulty,
  total = 3,
  onRating,
  ...rest
}) {
  const [selected, setSelected] = useState();

  useEffect(() => {
    setSelected(difficultyParsed[difficulty]);
  }, [difficulty]);

  return (
    <Rating
      name="difficulty"
      stop={total}
      emptySymbol={
        <span>
          <ChefHat className="rate" />
        </span>
      }
      fullSymbol={
        <span className="rate active">
          <ChefHat />
        </span>
      }
      initialRating={selected}
      readonly={!onRating}
      onChange={
        onRating
          ? (rate) => {
              setSelected(rate);
              onRating({
                target: { value: difficultyParsed[rate], name: "difficulty" },
              });
            }
          : null
      }
      className="difficultyRate"
      {...rest}
    />
  );
}
